import getServiceToken from '../data/ServiceAccountAccess';
import sheetConstants from '../data/sheetConstants';

import {attendeeToSheetRow} from './attendeeToSheetRow';

const updateSheetRange = (parameters) => ({
    data: [{
        dataFilter: {
            developerMetadataLookup: {
                metadataKey: 'id',
                metadataLocation: {
                    sheetId: sheetConstants.reservationsSheetId
                },
                metadataValue: parameters.attendeeId
            }
        },
        majorDimension: 'ROWS',
        values: attendeeToSheetRow(parameters, parameters.attendeeId)
    }],
    valueInputOption: 'USER_ENTERED'
});

const updateParticipant = async (parameters) => {
    const response = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${parameters.sheetId}/values:batchUpdateByDataFilter`, {
        body: JSON.stringify(updateSheetRange(parameters)),
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${parameters.bearerToken}`,
            'Content-type': 'application/json'
        },
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    return parameters.attendeeId;
};

export default async (sheetId, attendee) => {
    const bearerToken = await getServiceToken();

    const parameters = {
        ...attendee,
        bearerToken,
        sheetId
    };

    return updateParticipant(parameters);
};



// WEBPACK FOOTER //
// ./src/event/updateReservation.js